function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NAVIGATION_ENTRY_KEYS = ['name', 'type', 'startTime', 'transferSize', 'duration'];

function isNavigationEntryEqual(a) {
  return function (b) {
    return NAVIGATION_ENTRY_KEYS.every(function (key) {
      return a[key] === b[key];
    });
  };
}
/**
 * There are some difficulties diagnosing why there are duplicate navigation
 * entries. We've witnessed several intermittent results:
 * - duplicate entries have duration = 0
 * - duplicate entries are the same object reference
 * - none of the above
 *
 * Compare the values of several keys to determine if the entries are duplicates or not.
 */
// TODO (high-prio): Figure out wth is returned here
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type


function dedupePerformanceEntries(currentList, newList) {
  // Partition `currentList` into 3 different lists based on entryType
  var _currentList$reduce = currentList.reduce(function (acc, entry) {
    if (entry.entryType === 'navigation') {
      acc[0].push(entry);
    } else if (entry.entryType === 'largest-contentful-paint') {
      acc[1].push(entry);
    } else {
      acc[2].push(entry);
    }

    return acc;
  }, [[], [], []]),
      _currentList$reduce2 = _slicedToArray(_currentList$reduce, 3),
      existingNavigationEntries = _currentList$reduce2[0],
      existingLcpEntries = _currentList$reduce2[1],
      existingEntries = _currentList$reduce2[2];

  var newEntries = [];
  var newNavigationEntries = [];
  var newLcpEntry = existingLcpEntries.length ? existingLcpEntries[existingLcpEntries.length - 1] // Take the last element as list is sorted
  : undefined;
  newList.forEach(function (entry) {
    if (entry.entryType === 'largest-contentful-paint') {
      // We want the latest LCP event only
      if (!newLcpEntry || newLcpEntry.startTime < entry.startTime) {
        newLcpEntry = entry;
      }

      return;
    }

    if (entry.entryType === 'navigation') {
      var navigationEntry = entry; // Check if the navigation entry is contained in currentList or newList

      if ( // Ignore any navigation entries with duration 0, as they are likely duplicates
      entry.duration > 0 && // Ensure new entry does not already exist in existing entries
      !existingNavigationEntries.find(isNavigationEntryEqual(navigationEntry)) && // Ensure new entry does not already exist in new list of navigation entries
      !newNavigationEntries.find(isNavigationEntryEqual(navigationEntry))) {
        newNavigationEntries.push(navigationEntry);
      } // Otherwise this navigation entry is considered a duplicate and is thrown away


      return;
    }

    newEntries.push(entry);
  }); // Re-combine and sort by startTime

  return [].concat(_toConsumableArray(newLcpEntry ? [newLcpEntry] : []), _toConsumableArray(existingNavigationEntries), _toConsumableArray(existingEntries), newEntries, newNavigationEntries).sort(function (a, b) {
    return a.startTime - b.startTime;
  });
}

export { dedupePerformanceEntries };